import { Link, useLocation } from 'react-router-dom';
import { Briefcase, Users, Sofa, ArrowLeft } from 'lucide-react';

/**
 * Internal nav bar for the Furniture section. Sits at the top of the page
 * and switches between "Projects", "Staffing", and "Room Defaults".
 */
export function FurnitureNavBar() {
  const { pathname } = useLocation();
  const tabs = [
    { to: '/furniture-projects', label: 'Projects', icon: Briefcase, match: (p) => p === '/furniture-projects' || (p.startsWith('/furniture-projects/') && !p.startsWith('/furniture-projects/staffing') && !p.startsWith('/furniture-projects/share') && !p.startsWith('/furniture-projects/view') && !p.startsWith('/furniture-projects/room-defaults')) },
    { to: '/furniture-projects/staffing', label: 'Staffing', icon: Users, match: (p) => p.startsWith('/furniture-projects/staffing') },
    { to: '/furniture-projects/room-defaults', label: 'Room Defaults', icon: Sofa, match: (p) => p.startsWith('/furniture-projects/room-defaults') },
  ];
  return (
    <nav className="border-b bg-card/60 backdrop-blur sticky top-0 z-30" data-testid="furniture-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center gap-1 h-12">
        <Link
          to="/"
          className="mr-1 pl-1 pr-2.5 h-8 rounded-full inline-flex items-center gap-1 text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          title="Back to dashboard"
          data-testid="furniture-back-dashboard"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> Dashboard
        </Link>
        <div className="h-4 w-px bg-border mr-1" />
        {tabs.map(t => {
          const active = t.match(pathname);
          const Icon = t.icon;
          return (
            <Link
              key={t.to}
              to={t.to}
              className={`px-3 h-8 rounded-full inline-flex items-center gap-1.5 text-sm font-medium transition-colors ${
                active ? 'bg-primary text-primary-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
              data-testid={`furniture-nav-${t.label.toLowerCase()}`}
            >
              <Icon className="h-3.5 w-3.5" />{t.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
